var _rect, _path, _rect2, _rect3, _rect4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPopupLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    fillOpacity: 0.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 4H12V6H6V18H12V20H4V4Z",
    fill: "#407EDB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 7,
    transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 16.3599 8.47021)",
    fill: "#2A2C2F"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 2,
    transform: "matrix(-1 0 0 1 20.9985 11.0005)",
    fill: "#2A2C2F"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 2,
    transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 16.3638 15.54)",
    fill: "#2A2C2F"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopupLogin);
export default __webpack_public_path__ + "static/media/popup_login.cf24b650cfeebf1e70b900962595af7b.svg";
export { ForwardRef as ReactComponent };